import { render, staticRenderFns } from "./fts.vue?vue&type=template&id=1feaaa94&scoped=true&"
import script from "./fts.vue?vue&type=script&lang=js&"
export * from "./fts.vue?vue&type=script&lang=js&"
import style0 from "./fts.vue?vue&type=style&index=0&id=1feaaa94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feaaa94",
  null
  
)

export default component.exports